import debounce from 'lodash/debounce'
import { useCallback, useContext, useEffect } from 'react'
import { MenuStoreContext } from 'stores/MenuStore'

export function useSetVerticalScroll(active = true) {
  const { setVerticalScroll } = useContext(MenuStoreContext)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleScroll = useCallback(
    debounce(() => {
      setVerticalScroll(window.scrollY)
    }, 100),
    [setVerticalScroll],
  )

  useEffect(() => {
    if (active) window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [active, handleScroll])
}
